var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_38664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0677 52.8132L29.9321 34.8132L34.2033 36.6437L43.3558 37.2539C44.6779 38.3725 47.3219 40.6709 47.3219 40.9149C47.3219 41.159 48.1355 43.2539 48.5423 44.2708L46.4067 53.1183L39.6948 54.6437L32.0677 52.8132Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 30.9235C74.6131 24.4889 73.6825 21.0558 71.1187 15.9744L45.1865 37.9404V53.8048C62.1453 50.6434 69.9549 46.8796 76 30.9235Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 30.9235C5.38686 24.4889 6.31752 21.0558 8.88135 15.9744L34.8135 37.9404V53.8048C17.8547 50.6434 10.0451 46.8796 4 30.9235Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2083 21.1611C81.1866 -1.72037 -1.4911 -1.72036 10.1067 21.1611C12.1406 24.3136 16.2084 30.7407 16.2084 31.2289C16.2084 31.717 30.649 35.0933 37.8693 36.7204H42.1405C47.5303 36.6187 58.0659 38.0017 58.31 38.2458C58.5541 38.4899 66.3439 26.9577 70.2083 21.1611Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9323 26.0428C51.8984 18.7208 24.7459 19.3309 14.373 26.0428L22.0002 41.6021L38.4747 36.9496H41.8306L58.6103 43.1275L65.9323 26.0428Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_490_38664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1528 55.0256C11.0009 41.7377 11.023 34.5542 10.1072 21.2374C17.1502 29.8281 23.3986 33.2853 38.4748 36.7206L13.1528 55.0256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.102 21.1613C11.0231 34.5269 10.9968 41.7124 13.1528 55.0256L38.4748 36.7206C23.1775 33.235 16.9688 29.7267 9.79688 20.8562",
    stroke: "#999999",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.8135 53.5C38.8594 54.8571 41.141 54.7788 45.1863 53.5",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_490_38664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4576 55.0256C69.6094 41.7377 69.5873 34.5542 70.5032 21.2374C63.4602 29.8281 57.2118 33.2853 42.1356 36.7206L67.4576 55.0256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5084 21.1613C69.5872 34.5269 69.6135 41.7124 67.4576 55.0256L42.1356 36.7206C57.4328 33.235 63.6415 29.7267 70.8135 20.8562",
    stroke: "#999999",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_490_38664",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2757,
    cy: 46.2783,
    rx: 2.66364,
    ry: 3.04416,
    transform: "rotate(27.5023 40.2757 46.2783)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2757,
    cy: 46.2783,
    rx: 2.66364,
    ry: 3.04416,
    transform: "rotate(27.5023 40.2757 46.2783)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9774 46.123C39.9149 46.243 39.8474 46.2682 39.862 46.2625C39.8719 46.2587 39.9146 46.2442 39.9893 46.2464C40.0684 46.2487 40.1639 46.2699 40.2553 46.3175L37.4846 51.6394C40.5817 53.2519 43.9374 51.5097 45.2993 48.8937L39.9774 46.123ZM40.2553 46.3175C40.3468 46.3651 40.4189 46.4312 40.4662 46.4947C40.5108 46.5546 40.5234 46.5979 40.5259 46.6082C40.5296 46.6234 40.5116 46.5536 40.5741 46.4336L35.2521 43.6629C33.8902 46.2789 34.3875 50.027 37.4846 51.6394L40.2553 46.3175ZM40.5741 46.4336C40.6365 46.3137 40.7041 46.2884 40.6894 46.2941C40.6796 46.298 40.6369 46.3125 40.5622 46.3103C40.483 46.3079 40.3876 46.2868 40.2961 46.2391L43.0668 40.9172C39.9697 39.3048 36.6141 41.047 35.2521 43.6629L40.5741 46.4336ZM40.2961 46.2391C40.2047 46.1915 40.1326 46.1255 40.0853 46.062C40.0406 46.0021 40.028 45.9588 40.0255 45.9485C40.0218 45.9332 40.0398 46.003 39.9774 46.123L45.2993 48.8937C46.6613 46.2777 46.1639 42.5296 43.0668 40.9172L40.2961 46.2391Z",
    fill: "#999999",
    mask: "url(#path-11-inside-1_490_38664)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_490_38664",
    x: 4.60547,
    y: 19.9131,
    width: 41.4341,
    height: 45.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_490_38664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_490_38664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_490_38664",
    x: 34.5708,
    y: 19.9131,
    width: 41.4341,
    height: 45.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_490_38664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_490_38664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_38664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWing);
export default __webpack_public_path__ + "static/media/wing.6e9e3d899257c1ab08e6ec37cfec7688.svg";
export { ForwardRef as ReactComponent };